import { useCallback } from "react";
import { readWorkflowPlans, type StepPlan } from "../../../api/content/stepPlans";
import { useProjects } from "../../../projects/projectContext";
import { useLoad } from "../../../shared/loading/useLoad";
import type { ProcessScope } from "./useProcess";

const NO_PLANS: ReadonlyMap<string, StepPlan> = new Map();

/**
 * The Workflow's step plans before anything ran, by flat step key, as module B gives them in the project the view
 * reads (`useProcess`'s scope): what its cards show the placements' axes from (WD-1+3). Empty while they load,
 * without a project, and when the server can't plan the Workflow there: the cards then show no axis, never a guess.
 */
export function useWorkflowPlans(reference: string, scope: ProcessScope | null): ReadonlyMap<string, StepPlan> {
  const selectedProjectId = useProjects().selectedProjectId;
  const projectId = scope?.projectId ?? selectedProjectId;
  const commit = scope?.commit ?? null;
  const load = useCallback(
    (signal: AbortSignal) => (projectId === null ? Promise.resolve(NO_PLANS) : readWorkflowPlans(projectId, reference, commit, signal)),
    [projectId, reference, commit],
  );
  const { state } = useLoad(load);
  return state.status === "loaded" ? state.value : NO_PLANS;
}
